import React, { useState, useEffect, useMemo } from "react";
import QuizApi from "../../api/QuizApi";
import "../../styles/Quiz.css"; // Asegúrate de que este archivo exista y contenga los estilos

// Switch personalizado
const Switch = ({ checked, onChange }) => (
  <div className="switch-wrapper">
    <label className="switch">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="slider" />
    </label>
    <span style={{ marginLeft: 10, marginRight: 2 }}>Mostrar respuestas con más de 2 partículas</span>
  </div>
);

const Quiz = () => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [score, setScore] = useState(0);
  const [shuffledOptions, setShuffledOptions] = useState([]);
  const [showMulti, setShowMulti] = useState(false);

  useEffect(() => {
    const fetchQuestions = async () => {
      const cached = sessionStorage.getItem("quiz-particulas");
      if (cached) {
        setQuestions(JSON.parse(cached));
        return;
      }
      try {
        const data = await QuizApi.fetchQuestions();
        setQuestions(data);
        sessionStorage.setItem("quiz-particulas", JSON.stringify(data));
      } catch (error) {
        console.error("Error al cargar las preguntas:", error);
      }
    };
    fetchQuestions();
  }, []);

  const filteredQuestions = useMemo(() => {
    return showMulti
      ? questions
      : questions.filter(
          (q) => q.particula_correcta && q.particula_correcta.split(",").length < 3
        );
  }, [questions, showMulti]);

  useEffect(() => {
    setCurrentQuestionIndex(0);
    setSelectedOption(null);
  }, [filteredQuestions]);

  useEffect(() => {
    if (filteredQuestions.length > 0 && currentQuestionIndex < filteredQuestions.length) {
      const currentQuestion = filteredQuestions[currentQuestionIndex];
      if (currentQuestion) {
        const options = [
          currentQuestion.particula_correcta,
          currentQuestion.opcion_incorrecta_1,
          currentQuestion.opcion_incorrecta_2,
          currentQuestion.opcion_incorrecta_3,
        ].filter(opt => opt !== undefined && opt !== null);
        
        if (options.length > 0) {
          setShuffledOptions(options.sort(() => Math.random() - 0.5));
        } else {
          setShuffledOptions([]);
        }
      } else {
        setShuffledOptions([]);
      }
    } else {
      setShuffledOptions([]);
    }
  }, [filteredQuestions, currentQuestionIndex]);

  const handleOptionClick = (option) => {
    if (!selectedOption && filteredQuestions[currentQuestionIndex]) {
      setSelectedOption(option);
      if (option === filteredQuestions[currentQuestionIndex].particula_correcta) {
        setScore((prevScore) => prevScore + 1);
      }
    }
  };

  const handleNextQuestion = () => {
    setSelectedOption(null);
    setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
  };

  const handleSwitchChange = () => {
    setShowMulti((prevShowMulti) => !prevShowMulti);
  };
  
  if (!questions.length) {
    return (
      <div style={{ paddingTop: "30px" }}>
        <Switch checked={showMulti} onChange={handleSwitchChange} />
        <p style={{ marginTop: 20 }}>Cargando preguntas...</p>
      </div>
    );
  }

  if (filteredQuestions.length === 0) {
    return (
      <div style={{ paddingTop: "30px" }}>
        <Switch checked={showMulti} onChange={handleSwitchChange} />
        <p style={{ marginTop: 20 }}>
          {showMulti ? "No hay preguntas disponibles con la configuración actual." : "No hay preguntas con menos de 3 partículas disponibles. Intenta activar el switch."}
        </p>
      </div>
    );
  }
  
  const currentQuestion = filteredQuestions[currentQuestionIndex];
  if (!currentQuestion) {
    return (
      <div style={{ paddingTop: "30px" }}>
        <Switch checked={showMulti} onChange={handleSwitchChange} />
        <p style={{ marginTop: 20 }}>Actualizando preguntas...</p>
      </div>
    );
  }

  return (
    <div style={{  }}>
      <Switch checked={showMulti} onChange={handleSwitchChange} />
      <h2>Pregunta {currentQuestionIndex + 1} de {filteredQuestions.length}</h2>
      <p>{currentQuestion.frase}</p>
      <div className="quiz-options">
        {shuffledOptions.map((option, index) => {
          const isCorrectAnswer = option === currentQuestion.particula_correcta;
          let optionClasses = ['quiz-option'];

          if (selectedOption) { // Si el usuario ya ha seleccionado una opción
            if (option === selectedOption) { // Estilos para la opción que el usuario seleccionó
              optionClasses.push(isCorrectAnswer ? 'correct' : 'incorrect');
            }
            // Siempre marcar la respuesta correcta con un borde especial si ya se hizo una selección
            if (isCorrectAnswer) {
              optionClasses.push('reveal-correct-answer');
            }
          }

          return (
            <button
              key={index}
              onClick={() => handleOptionClick(option)}
              className={optionClasses.join(' ')}
              disabled={!!selectedOption} // Deshabilitar opciones después de seleccionar una
            >
              {option}
            </button>
          );
        })}
      </div>
      {selectedOption && (
        <button onClick={handleNextQuestion} style={{ marginTop: "20px" }} disabled={currentQuestionIndex === filteredQuestions.length -1 && !selectedOption}>
          {currentQuestionIndex === filteredQuestions.length - 1 ? "Ver Resultados" : "Siguiente"}
        </button>
      )}
      {currentQuestionIndex === filteredQuestions.length - 1 && selectedOption && (
        <div>
          <h3>Tu puntuación: {score} / {filteredQuestions.length}</h3>
        </div>
      )}
    </div>
  );
};

export default Quiz;